import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinusSquare, faPlusSquare, faSquare } from "@fortawesome/free-regular-svg-icons";

const ThreeWayCheckbox = ({ onChange, value }) => {
    const handleClick = () => {
        const newValue = value === "true" ? "false" : value === "false" ? "" : "true";
        onChange(newValue);
    };

    const icon = value === "true" ? faPlusSquare : value === "false" ? faMinusSquare : faSquare;

    return (
        <div onClick={handleClick}>
            <FontAwesomeIcon icon={icon} />
        </div>
    );
};

export default ThreeWayCheckbox;
